import {
	AIRPORTS_URL,
	ALLIANCES_URL,
	getWebsiteUrl,
	IT_SYSTEMS_URL,
	renderLink,
} from "../search/result/renderers";

export function renderAllianceLink(value) {
	return renderLink(ALLIANCES_URL + value.get("code"), value.get("name"));
}

export function renderAllianceCodeLink(value) {
	return renderLink(ALLIANCES_URL + value, value);
}

export function renderEnginesLink(value) {
	return value.get("value") === 0
		? ""
		: renderLink(value.get("link"), value.get("value").toString());
}

export function renderFacebookLink(value) {
	return renderLink(
		"https://www.facebook.com/" + value,
		"Facebook",
		"",
		"_blank",
	);
}

export function renderLocationIdLink(value) {
	return renderLink(AIRPORTS_URL + value, value.toString());
}

export function renderPhoneLink(value) {
	return value.get("country_code") !== null
		? "+" + value.get("country_code") + " " + value.get("phone_number")
		: value.get("phone_number");
}

export function renderReservationSystemLink(value) {
	return renderLink(IT_SYSTEMS_URL + value.get("code"), value.get("name"));
}

export function renderReservationSystemCodeLink(value) {
	return renderLink(IT_SYSTEMS_URL + value, value);
}

export function renderStockMarketLink(value) {
	return renderLink(value, "Stock Market");
}

export function renderXLink(value) {
	return renderLink("https://x.com/" + value, "X", "", "_blank");
}

export function renderWebsiteLink(value) {
	if (!value) {
		return;
	}

	const url = getWebsiteUrl(value);
	return renderLink(url, url, "", "_blank");
}
